import { Button, Col, DatePicker, Form, Row } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import styled from "styled-components";

const StyledFilterContainer = styled.div`
  &,
  & .filter {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
    &__item {
      margin: 0.5rem;

      & .ant-form-item {
        margin: 0;
      }

      &--submit {
        align-self: flex-end;
      }
    }
  }
`;

export const AppGigPayoutsFilter = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [form] = Form.useForm();
  const [startDate, setStartDate] = useState<moment.Moment | undefined>();
  const [endDate, setEndDate] = useState<moment.Moment | undefined>();

  useEffect(() => {
    const sd = searchParams.get("startDate");
    const ed = searchParams.get("endDate");
    const sdMoment = sd ? moment(sd) : undefined;
    const edMoment = ed ? moment(ed) : undefined;
    form.setFieldsValue({ startDate: sdMoment, endDate: edMoment });
    setStartDate(sdMoment);
    setEndDate(edMoment);
  }, [form, searchParams]);

  const onSearch = (values: { startDate?: moment.Moment; endDate?: moment.Moment }) => {
    const params: Record<string, string> = {};
    if (values.startDate) params.startDate = values.startDate.format("YYYY-MM-DD");
    if (values.endDate) params.endDate = values.endDate.format("YYYY-MM-DD");
    setSearchParams(params);
  };

  const onReset = () => {
    form.resetFields();
    setStartDate(undefined);
    setEndDate(undefined);
    setSearchParams({});
  };

  return (
    <StyledFilterContainer>
      <Form
        form={form}
        name="gig-payouts-filter-form"
        onFinish={onSearch}
        layout="vertical"
        style={{ width: "100%" }}
      >
        <Row className="filter">
          <Col xs={20} sm={8} md={6} lg={5} className="filter__item">
            <Form.Item name="startDate" label="Start Date">
              <DatePicker
                size="small"
                style={{ width: "100%" }}
                disabledDate={(current) => {
                  if (!current) return false;
                  if (endDate) return current.isAfter(endDate, "day");
                  return false;
                }}
                onChange={(date) => setStartDate(date ?? undefined)}
              />
            </Form.Item>
          </Col>
          <Col xs={20} sm={8} md={6} lg={5} className="filter__item">
            <Form.Item name="endDate" label="End Date">
              <DatePicker
                size="small"
                style={{ width: "100%" }}
                disabledDate={(current) => {
                  if (!current) return false;
                  if (startDate) return current.isBefore(startDate, "day");
                  return false;
                }}
                onChange={(date) => setEndDate(date ?? undefined)}
              />
            </Form.Item>
          </Col>
          <Col xs={20} sm={4} md={2} lg={2} className="filter__item filter__item--submit">
            <Form.Item>
              <Button type="primary" htmlType="submit" size="small">
                Search
              </Button>
            </Form.Item>
          </Col>
          <Col xs={20} sm={4} md={2} lg={2} className="filter__item filter__item--submit">
            <Form.Item>
              <Button size="small" onClick={onReset}>
                Reset
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </StyledFilterContainer>
  );
};
